import React from 'react';
import { connect } from 'react-redux'
import { NAME as WPM_TEST_NAME } from '../reducer'
import { bindActionCreators } from 'redux'
import { actions as wpmTestContainerActions } from '../actions'
import WPMTestImg from "../../../assets/images/exercises/wpmtest_preex.svg";
import { CSSTransition } from "react-transition-group";
import Timer from "../../Timer/container/Timer"
import CountDown from "../../../components/CountDown";
import GameOver from "../../../components/GameOver";
import StartOverlay from "components/StartOverlay";
import { strings } from "../../../constants/strings";
import TextArea from "../components/TextArea"
import Questions from "../components/Questions"
import TextSelector from "../components/TextSelector"
import 'assets/css/wpmTest.css'
import { analyticsActions } from "constants/analytics-actions-id";

const lang = document.documentElement.lang.slice(0, 2);
const INFINITY = 2000000000

function mapStateToProps(state) {
  return {
    ...state[WPM_TEST_NAME]
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...wpmTestContainerActions,
  dispatch
}, dispatch)

const calcWpmRate = ({ wordsInText, endTime, startTime }) => {
  return Math.min(
    Math.floor((wordsInText / ((endTime - startTime) / 1000)) * 60),
    1500
  );
}

class WPMTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startOverlayTransitionIsFinished: false,
      progressInfoTransitionIsFinished: false
    }
  }

  componentWillUnmount() {

  }

  render() {
    if (this.props.exersizeState === 'gameOver') {
      this.timer = setTimeout(() => {
        this.props.dispatch({ type: "SHOW_GAME_OVER_SCREAN" });
      }, 1200);
    }
    return (
      <div className='App exercise-container'>
        <CSSTransition
          in={this.props.exersizeState === 'startScrean'}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={() => this.setState({ startOverlayTransitionIsFinished: true })}
        >
          <StartOverlay
            img={WPMTestImg}
            name={strings.WPMDetection_TP}
            title={strings.WPMTest_title}
            description={strings.WPMTest_description}
            btnText={strings.OverlayView_btn_start}
            btnId={analyticsActions.WpmTest.btnStart}
            onClick={() => { this.props.startPreExersize() }}
            advancedComponent={<TextSelector
              setText={this.props.setText}
              textSelectorIsVisible={this.props.textSelectorIsVisible}
              showTxtSelector={this.props.showTxtSelector}
              hideTxtSelector={this.props.hideTxtSelector}
              textName={this.props.textName}
              textLevel={this.props.textLevel}
            />}
          />
        </CSSTransition>
        <CSSTransition
          in={this.props.exersizeState === 'scoreScrean' && this.state.progressInfoTransitionIsFinished}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
        >
          <GameOver
            title={strings.WPMTest_name}
            points={this.props.points}
            analyticsActions={analyticsActions.WpmTest}
          >
            <div className="results-div">
              <div className='caption'
                dangerouslySetInnerHTML={{ __html: strings.WpM_Postexercise_WpMscore }}
              ></div>
              <div
                className="score"
                style={{ fontSize: "36px", textAlign: "right" }}
              >
                {calcWpmRate({
                  endTime: this.props.endTime,
                  wordsInText: this.props.wordsInText,
                  startTime: this.props.startTime,
                })}
              </div>
            </div>
            <div className="results-div">
              <div className='caption'
                dangerouslySetInnerHTML={{ __html: strings.WpM_Postexercise_retentionscore }}
              ></div>
              <div
                className="score"
                style={{ fontSize: "36px", textAlign: "right" }}
              >
                {(this.props.points / 4) * 100}%
                </div>
            </div>
          </GameOver>
        </CSSTransition>
        <CSSTransition
          in={
            (
              this.props.exersizeState === 'preexersize' ||
              this.props.exersizeState === 'gameStarted' ||
              this.props.exersizeState === 'questions' ||
              this.props.exersizeState === 'gameOver'
            ) && this.state.startOverlayTransitionIsFinished
          }
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited={() => this.setState({ progressInfoTransitionIsFinished: true })}
        >
          <>
            <CountDown key="countDown" countDown={this.props.countDown} />
            <div className='progress-container'>
              <CSSTransition
                in={
                  this.props.exersizeState === 'gameStarted' ||
                  this.props.exersizeState === 'questions'
                }
                classNames="opacity-transition"
                timeout={250}
                mountOnEnter
                unmountOnExit
              >
                <>
                  <div className="info wpm-test-head">
                    <h2>{strings.WPMTest_name}</h2>
                    <div className="row">
                      <div className="col-md-12">{strings.WPMTest_title}</div>
                    </div>
                  </div>
                </>
              </CSSTransition>
              <div className='wpm-progress-game'>
                <CSSTransition
                  in={this.props.exersizeState === 'gameStarted'}
                  timeout={200}
                  classNames='opacity-transition'
                  mountOnEnter
                  unmountOnExit
                  onExited={() => {
                    this.setState({ transitionIsFinished: true })
                  }}
                >
                  <TextArea
                    text={this.props.text}
                    readingFinishedAction={this.props.readingFinishedAction}
                    readingFinished={this.props.readingFinished}
                    showQuestions={this.props.showQuestions}
                  />
                </CSSTransition>
                <CSSTransition
                  in={this.props.exersizeState === 'questions' && this.state.transitionIsFinished}
                  timeout={200}
                  classNames='opacity-transition'
                  mountOnEnter
                  unmountOnExit
                >
                  <div className="field-q">
                    <Questions
                      questions={this.props.questions}
                      currentQuestionIndex={this.props.currentQuestionIndex}
                      onAnswerClick={this.props.answerClick}
                      showAnswerRight={this.props.showAnswerRight}
                      answerKey={this.props.answerIndex}
                      nextQuestion={this.props.nextQuestion}
                      questionSwitched={this.props.questionSwitched}
                    />
                  </div>
                </CSSTransition>

              </div>
            </div>
          </>
        </CSSTransition>
        <Timer
          started={this.props.exersizeState === 'preexersize'}
          increment={this.props.incrementCountDown}
          interval={1000}
          incrementCounter={this.props.countDown}
          timerFinished={this.props.startGame}
        />
      </div >
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(WPMTest)
